import {
  practiceAreaConfigService,
  type FirmSettings,
  type PracticeArea
} from './practiceAreaConfigService';
import type { SystemPreferences } from '../features/admin/services/SystemPreferencesAPI';
import type { ServiceAreaNumberingConfig } from '../types/matterNumbering';

export type ServiceArea = PracticeArea;
export type SubscriberSettings = FirmSettings;

export const serviceAreaConfigService = {
  getAvailableServiceAreas(): Promise<ServiceArea[]> {
    return practiceAreaConfigService.getAvailablePracticeAreas();
  },

  getSubscriberSettings(): Promise<SubscriberSettings> {
    return practiceAreaConfigService.getFirmSettings();
  },

  getSelectedServiceAreas(): Promise<string[]> {
    return practiceAreaConfigService.getSelectedPracticeAreas();
  },

  isServiceAreaSelected(serviceAreaName: string): Promise<boolean> {
    return practiceAreaConfigService.isPracticeAreaSelected(serviceAreaName);
  },

  getServiceAreaConfig(serviceArea: string): Promise<ServiceAreaNumberingConfig | null> {
    return practiceAreaConfigService.getPracticeAreaConfig(serviceArea);
  },

  getAllServiceAreaConfigs(): Promise<ServiceAreaNumberingConfig[]> {
    return practiceAreaConfigService.getAllPracticeAreaConfigs();
  },

  updateServiceAreaConfig(
    serviceArea: string,
    config: Partial<ServiceAreaNumberingConfig>
  ): Promise<void> {
    return practiceAreaConfigService.updatePracticeAreaConfig(serviceArea, config);
  },

  toSystemPreferencesUpdate(subscriberSettings: SubscriberSettings): Partial<SystemPreferences> {
    return practiceAreaConfigService.toSystemPreferencesUpdate(subscriberSettings);
  },

  clearCache(): void {
    practiceAreaConfigService.clearCache();
  },

  getServiceAreaDisplayName(serviceAreaName: string): Promise<string> {
    return practiceAreaConfigService.getPracticeAreaDisplayName(serviceAreaName);
  },

  validateServiceAreaConfig(config: ServiceAreaNumberingConfig): { isValid: boolean; errors: string[] } {
    return practiceAreaConfigService.validatePracticeAreaConfig(config);
  }
};
